import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetaxiservice() {



  const cardData = {
  "keyword": "Pune Taxi Service",

"headingDescription":
  "Shivai Travels offers professional and affordable Pune Taxi Service for local travel, airport transfers, corporate rides, outstation trips, family outings, and daily transportation needs. With experienced drivers, clean and well-maintained vehicles, transparent pricing, and punctual service, we ensure a safe and comfortable travel experience across Pune and nearby destinations. Our taxi fleet includes air-conditioned sedans, spacious SUVs, and premium cars suitable for individuals, families, tourists, and business travelers. Whether you need a quick city ride, railway station pickup, airport taxi, or full-day cab booking, Shivai Travels provides reliable transportation solutions with easy online booking and 24/7 customer support.",

"topPlaces": [
  {
    "title": "Pune Airport Pickup & Drop",
    "description": "Pune Taxi Service offers reliable airport pickup and drop facilities for both domestic and international travelers. Comfortable rides, timely arrivals, and hassle-free transfers make airport travel smooth and convenient."
  },
  {
    "title": "Pune Railway Station Taxi Service",
    "description": "Taxi service from Pune Railway Station ensures quick and easy connectivity to hotels, business hubs, and residential areas. Ideal for passengers arriving in the city needing instant transport."
  },
  {
    "title": "Corporate Taxi Service in Pune",
    "description": "Pune Taxi Service provides professional corporate travel solutions for office meetings, business trips, and daily employee transport with punctual and comfortable rides."
  },
  {
    "title": "Outstation Cab from Pune",
    "description": "Outstation taxi service from Pune covers popular routes like Mumbai, Nashik, Shirdi, Goa, and Mahabaleshwar with safe, long-distance travel and experienced drivers."
  },
  {
    "title": "Local City Ride in Pune",
    "description": "Pune local taxi service is perfect for daily travel within the city including shopping, office commute, hospital visits, and personal errands with affordable pricing."
  },
  {
    "title": "Pune to Mumbai Cab Service",
    "description": "One of the most booked routes, Pune to Mumbai taxi service offers comfortable highway travel with flexible pickup and drop options for business and leisure travelers."
  },
  {
    "title": "Pune Hotel Transfer Service",
    "description": "Taxi service in Pune includes smooth hotel transfers for tourists and business visitors, ensuring quick access to accommodations across the city."
  },
  {
    "title": "Pune One Way Cab Service",
    "description": "One-way cab service from Pune is ideal for travelers who don’t require a return trip, offering cost-effective and flexible travel options across cities."
  },
  {
    "title": "Pune Family & Group Travel Cab",
    "description": "Spacious vehicles like Innova, Ertiga, and Tempo Traveller are available for family and group travel in Pune, ensuring comfortable long and short-distance journeys."
  },
  {
    "title": "Pune Wedding & Event Cab Service",
    "description": "Special event transportation in Pune includes wedding car rentals, guest pickup services, and luxury travel options for smooth event logistics."
  }
],



services: [
  {
    name: "Pune Taxi Service",
    description: "Pune taxi service provides reliable transportation for local travel, airport transfers, business trips, and outstation journeys across Pune. Comfortable vehicles with experienced drivers ensure safe and smooth travel for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Vehicles include sedan cars, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel needs. Flexible booking options allow convenient one-way and round-trip ride reservations."
  },
  {
    name: "Taxi Service in Pune",
    description: "Taxi service in Pune offers convenient cab transportation for passengers traveling within Pune city and nearby destinations. Well-maintained vehicles provide comfortable seating and smooth city travel experience for daily commuters, tourists, and corporate travelers. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including residential areas, offices, hotels, railway stations, and airports. Flexible booking options allow easy travel planning for passengers."
  },
  {
    name: "Best Taxi Service Pune",
    description: "Best taxi service Pune provides dependable transportation with professional drivers and comfortable vehicles for city and outstation travel. Vehicles are suitable for airport transfers, corporate travel, local sightseeing, and family transportation needs. Professional chauffeurs ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient taxi reservations for passengers."
  },
  {
    name: "Online Taxi Booking Pune",
    description: "Online taxi booking Pune service allows passengers to conveniently reserve cabs for local and outstation travel through quick booking options. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium cars suitable for different travel requirements. Professional drivers ensure safe and timely transportation services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Affordable Taxi Pune",
    description: "Affordable taxi Pune service provides budget-friendly transportation for passengers looking for economical travel within Pune and nearby destinations. Comfortable vehicles ensure reliable city travel while maintaining affordable pricing for daily commuters and travelers. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient and cost-effective travel planning."
  },
  {
    name: "Local Taxi Pune",
    description: "Local taxi Pune service offers comfortable transportation for daily travel, shopping trips, office commutes, and city sightseeing within Pune. Vehicles provide smooth city travel with experienced drivers ensuring safe and convenient journeys. Pickup services are available across residential areas, hotels, offices, railway stations, and airports in Pune. Ideal for tourists, families, and business travelers. Flexible booking options allow easy local taxi reservations."
  },
  {
    name: "24 Hour Taxi Service Pune",
    description: "24 hour taxi service Pune provides round-the-clock transportation for passengers traveling within Pune and nearby destinations at any time of day or night. Comfortable vehicles and experienced drivers ensure safe and reliable travel services for airport transfers, emergencies, and business travel. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient cab reservations anytime."
  },
  {
    name: "Pune City Taxi",
    description: "Pune city taxi service offers dependable transportation for local travel across Pune city with comfortable vehicles and professional drivers. Vehicles are suitable for office travel, shopping trips, tourism, and family transportation requirements. Professional drivers ensure punctual pickup and safe driving services throughout the city. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient city travel reservations."
  },
  {
    name: "Cab and Taxi Service Pune",
    description: "Cab and taxi service Pune provides reliable transportation solutions for local travel, airport transfers, corporate trips, and outstation journeys. Well-maintained vehicles offer comfortable seating and smooth travel experience for passengers. Professional drivers ensure safe journeys and timely pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient travel planning for individuals and groups."
  },
  {
    name: "Reliable Taxi Pune",
    description: "Reliable taxi Pune service provides trusted transportation with experienced drivers and comfortable vehicles for local and outstation travel. Vehicles are maintained for passenger safety and smooth travel experience across city roads and highways. Professional chauffeurs ensure punctual pickup and dependable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow easy ride reservations."
  },
  {
    name: "Airport Taxi Pune",
    description: "Airport taxi Pune service offers comfortable airport transportation for passengers traveling to and from Pune Airport. Vehicles provide spacious seating and luggage capacity suitable for airport transfers and travel convenience. Professional drivers ensure punctual pickup and safe transportation services for domestic and international travelers. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport ride scheduling."
  },
  {
    name: "Corporate Taxi Pune",
    description: "Corporate taxi Pune service provides professional transportation solutions for business travelers, company employees, and corporate events. Comfortable vehicles ensure smooth city and airport travel with experienced chauffeurs maintaining punctuality and professionalism. Pickup services are available from offices, hotels, residential areas, railway stations, and airports. Ideal for employee transport, client meetings, and business travel requirements. Flexible booking options allow convenient corporate cab reservations."
  },
  {
    name: "Cheap Taxi Pune",
    description: "Cheap taxi Pune service offers economical transportation for passengers looking for affordable city and airport travel options. Comfortable vehicles ensure reliable travel experience while maintaining budget-friendly pricing for passengers. Professional drivers provide safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient low-cost travel planning."
  },
  {
    name: "Private Taxi Pune",
    description: "Private taxi Pune service provides exclusive transportation for passengers seeking comfortable and personalized travel experience. Vehicles offer privacy, spacious seating, and smooth city travel suitable for families, tourists, and corporate travelers. Professional drivers ensure safe and punctual transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient private cab reservations."
  },
  {
    name: "AC Taxi Pune",
    description: "AC taxi Pune service offers air-conditioned transportation for comfortable travel within Pune city and nearby destinations. Vehicles provide comfortable seating and pleasant travel experience suitable for daily commutes, airport transfers, and business travel. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from residential areas, hotels, offices, railway stations, and airports. Flexible booking options allow convenient AC cab reservations."
  },
  {
    name: "Pune Airport Pickup and Drop",
    description: "Pune Airport pickup and drop service provides reliable airport transportation for passengers traveling to and from Pune Airport terminals. Comfortable vehicles offer spacious seating and luggage space suitable for airport journeys. Professional drivers ensure punctual airport pickups and safe transportation services for travelers. Pickup services are available from homes, hotels, offices, railway stations, and nearby locations across Pune. Flexible booking options allow convenient airport transfer reservations."
  }
],

tableData: [
  ["Pune Taxi Service", "Taxi Service in Pune"],
  ["Best Taxi Service Pune", "Online Taxi Booking Pune"],
  ["Affordable Taxi Pune", "Local Taxi Pune"],
  ["24 Hour Taxi Service Pune", "Pune City Taxi"],
  ["Cab and Taxi Service Pune", "Reliable Taxi Pune"],
  ["Airport Taxi Pune", "Corporate Taxi Pune"],
  ["Cheap Taxi Pune", "Private Taxi Pune"],
  ["AC Taxi Pune", "Pune Airport Pickup and Drop"]
],



 whychoose: [
      {
        WhyChooseheading: "Experienced Local & Outstation Drivers",
        WhyChoosedescription: "Shivai Travels provides experienced drivers for Pune taxi service who are familiar with city routes, highways, airport transfers, and nearby tourist destinations for safe and smooth travel."
      },
      {
        WhyChooseheading: "Affordable Taxi Service in Pune",
        WhyChoosedescription: "Shivai Travels offers affordable Pune taxi service with transparent pricing and no hidden charges. Customers receive clear fare information before confirming their cab booking."
      },
      {
        WhyChooseheading: "24/7 Pune Taxi Availability",
        WhyChoosedescription: "Our Pune taxi service operates 24 hours a day for airport transfers, local travel, outstation trips, business meetings, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Clean & Comfortable AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, regularly sanitized, and well maintained to provide comfortable travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Taxi Booking",
        WhyChoosedescription: "Shivai Travels offers flexible taxi booking options including one-way taxi service, round-trip travel, local Pune sightseeing, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicles",
        WhyChoosedescription: "Customers can choose from sedan cars, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and groups."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune City",
        WhyChoosedescription: "Shivai Travels provides doorstep pickup from homes, offices, hotels, Pune Airport, railway stations, and all major locations including Baner, Wakad, Kharadi, Hadapsar, and Hinjewadi."
      },
      {
        WhyChooseheading: "Reliable Pune Taxi Service",
        WhyChoosedescription: "Shivai Travels is trusted by customers for reliable Pune taxi service with punctual drivers, comfortable vehicles, professional support, and smooth transportation solutions."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune taxi service?", answer: "Pune taxi service provides local and outstation transportation for airport transfers, city travel, business trips, and tourist travel." },
    { question: "Is Pune taxi service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune taxi service for all travel requirements." },
    { question: "Which vehicles are available for Pune taxi service?", answer: "Shivai Travels offers sedan cars, Ertiga, Innova, Innova Crysta, and Tempo Travellers for local and outstation travel." },
    { question: "Can I book a one-way taxi in Pune?", answer: "Yes, customers can book one-way taxi services as well as round-trip taxi bookings in Pune." },
    { question: "Do you provide Pune Airport taxi service?", answer: "Yes, Shivai Travels provides pickup and drop services for Pune Airport and railway stations." },
    { question: "Are all taxis air-conditioned?", answer: "Yes, all taxis provided by Shivai Travels are fully air-conditioned and well maintained." },
    { question: "Can I book Pune taxi service online?", answer: "Yes, customers can easily book Pune taxi service online or through phone booking." },
    { question: "Do you provide taxis for family trips?", answer: "Yes, Shivai Travels provides comfortable taxis for family tours, vacations, and group travel." },
    { question: "Are the taxi fares affordable?", answer: "Yes, Shivai Travels offers affordable and transparent taxi pricing for local and outstation travel." },
    { question: "Is advance booking available for Pune taxi service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback:
      "Pune taxi service from Shivai Travels was very smooth with a clean cab, polite driver, and timely pickup for my local travel needs.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Kulkarni",
    feedback:
      "The taxi service in Pune was reliable and comfortable, making my daily travel and short trips completely stress-free and convenient.",
    rating: 5
  }
];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Taxi Service",
  "image": "https://shivaitravels.com/assets/images/pune-taxi-service.jpg",
  "description": "Book reliable Pune taxi service for local travel, airport transfers, corporate trips, and outstation journeys. We offer affordable and comfortable AC taxis with 24x7 availability and online booking support.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-taxi-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune Taxi Service | Best & Affordable Cab Service in Pune | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune taxi service for local travel, airport pickup, corporate rides, and 24x7 cab service. Affordable, reliable, and AC taxi booking available online in Pune."
  />

  <meta
    name="keywords"
    content="Pune taxi service, taxi service in pune, best taxi service pune, online taxi booking pune, affordable taxi pune, local taxi pune, 24 hour taxi service pune, pune city taxi, cab and taxi service pune, reliable taxi pune, airport taxi pune, corporate taxi pune, cheap taxi pune, private taxi pune, ac taxi pune, Pune Taxi Service, Best Taxi Service in Pune, Cab Service in Pune, 24x7 Taxi Service Pune, Pune Airport Taxi Service, Online Cab Booking Pune, Cheap Taxi Service Pune, Pune Local Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetaxiservice;